const blockNameOf = (task) => (task?.blockName || '').trim() || 'Блок';

// Имена блоков, которые встречаются в разных проектах текущего списка.
export const duplicateBlockNames = (tasks) => {
    const projectsByName = new Map();
    (tasks ?? []).forEach((task) => {
        if (!task?.blockId) return;
        const name = blockNameOf(task);
        const projects = projectsByName.get(name) ?? new Set();
        projects.add(task.projectId);
        projectsByName.set(name, projects);
    });
    const duplicates = new Set();
    projectsByName.forEach((projects, name) => {
        if (projects.size > 1) duplicates.add(name);
    });
    return duplicates;
};

export const blockGroupLabel = (task, duplicateNames) => {
    if (!task?.blockId) return 'Без блока';
    const name = blockNameOf(task);
    if (duplicateNames?.has(name) && task.projectName) return `${task.projectName} · ${name}`;
    return name;
};

const cmpText = (a, b) => (a || '').localeCompare(b || '', 'ru', { sensitivity: 'accent' });

// Блоки идут по порядку, затем по подписи. Задачи без блока — в конце.
export const sortTasksByBlock = (tasks, compare) => {
    const duplicates = duplicateBlockNames(tasks);
    return [...(tasks ?? [])].sort((a, b) => {
        const blankA = !a.blockId;
        const blankB = !b.blockId;
        if (blankA !== blankB) return blankA ? 1 : -1;
        if (!blankA) {
            const byIdx = (a.blockIdx ?? 0) - (b.blockIdx ?? 0);
            if (byIdx) return byIdx;
            const byLabel = cmpText(blockGroupLabel(a, duplicates), blockGroupLabel(b, duplicates));
            if (byLabel) return byLabel;
            if (a.blockId !== b.blockId) return a.blockId - b.blockId;
        }
        return compare(a, b);
    });
};
